/**
 * Logique PURE du mode maintenance (SD-4367) — zéro import, testable en node:test.
 *
 * Le décompte se calcule TOUJOURS sur l'horloge serveur : `server_time` renvoyé
 * par le backend sert à calculer un offset vs l'horloge client (postes
 * potentiellement décalés), et `activates_at` est comparé à `Date.now() + offset`.
 */

export type MaintenanceStatus = 'off' | 'scheduled' | 'active'

export interface MaintenanceStatusPayload {
  status: MaintenanceStatus
  activates_at: string | null
  server_time: string
}

/** Offset horloge = serveur − client (ms). */
export function computeServerOffsetMs(serverTimeIso: string, clientNowMs: number): number {
  return Date.parse(serverTimeIso) - clientNowMs
}

/** Statut effectif côté client : un `scheduled` échu (horloge serveur) est `active`. */
export function effectiveStatus(
  payload: Pick<MaintenanceStatusPayload, 'status' | 'activates_at'>,
  serverNowMs: number,
): MaintenanceStatus {
  if (payload.status === 'scheduled' && payload.activates_at !== null && serverNowMs >= Date.parse(payload.activates_at)) {
    return 'active'
  }
  return payload.status
}

/** Secondes restantes avant activation (clampées ≥ 0), null si pas de décompte. */
export function computeRemainingSeconds(activatesAtIso: string | null, serverNowMs: number): number | null {
  if (activatesAtIso === null) return null
  const remaining = Math.ceil((Date.parse(activatesAtIso) - serverNowMs) / 1000)
  return remaining > 0 ? remaining : 0
}

/** Formate un décompte en MM:SS. */
export function formatCountdown(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
